import { v5, NIL } from 'uuid';

const CommentStatusList$1 = ['active', 'edited', 'removed'];

var CommentReactionTypes;
(function (CommentReactionTypes) {
    CommentReactionTypes["LIKE"] = "like";
    CommentReactionTypes["LOVE"] = "love";
    CommentReactionTypes["HAHA"] = "haha";
    CommentReactionTypes["WOW"] = "wow";
    CommentReactionTypes["YAY"] = "yay";
    CommentReactionTypes["SAD"] = "sad";
    CommentReactionTypes["ANGRY"] = "angry";
})(CommentReactionTypes || (CommentReactionTypes = {}));

var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["RATING_ADDED"] = 0] = "RATING_ADDED";
    NotificationType[NotificationType["MENTIONED"] = 1] = "MENTIONED";
    NotificationType[NotificationType["DEBATE_CLOSED"] = 2] = "DEBATE_CLOSED";
})(NotificationType || (NotificationType = {}));

const RatingStatusList = ['active', 'edited', 'removed'];

const CommentStatusList = ['active', 'edited', 'removed'];

const UserStatusList = ['active', 'pending', 'deactivated', 'blocked', 'suspended'];

const reasonPoints = {
    'debate-published': 1,
    'debate-published-manually': 2,
    'debate-scored': 10,
    'rating-published': 2,
    'rating-added': 4,
    'rating-liked': 5,
    'rating-disliked': -2,
    'rating-comment-liked': 1 // when rating comment upvoted;
};

const ViolationReasonList = [
    'spam',
    'harmful',
    'violent',
    'vulgarity',
    'misleading',
    'copyrighted',
    'advertisement',
    'other'
];
const ViolationStatusList = ['open', 'resolved', 'closed'];

// chunk array to a certain size
const arrayToChunks = (list, size) => {
    list = [...list];
    return [...Array(Math.ceil(list.length / size))].map((_) => list.splice(0, size));
};

const generateHash = (str) => {
    let hash = 0;
    const len = str.length;
    for (let i = 0; i < len; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0; // to 32bit integer
    }
    if (hash < 0) {
        hash *= -1;
    }
    return hash.toFixed(0);
};
const createId = (str) => v5(str, new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?').test(str) ? v5.URL : NIL).replace(/-/g, '');
const createSlugFromTitle = (title) => title
    .substring(0, 80)
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/-+/g, '-');

/*
 * Public API Surface of common
 */

const Database = {
    ARTICLE: 'article',
    ARTICLE_CONTEXT: 'article_context',
    ARTICLE_DEBATE_CONTEXT: 'article_debate_context',
    ARTICLE_DOMAIN: 'article_domain',
    AUTHOR: 'author',
    CATEGORY: 'category',
    NOTIFICATION: 'notification',
    PUBLISHER: 'publisher',
    RATING: 'rating',
    RATING_LIKE: 'like',
    RATING_CONTEXT: 'rating_context',
    COMMENT: 'comment',
    COMMENT_LIKE: 'like',
    COMMENT_CONTEXT: 'comment_context',
    RSS_FEED_DESCRIPTOR: 'rss_feed_descriptor',
    TWITTER_REFERENCE_USERS: 'twitter_reference_users',
    USER: 'user',
    USER_CONTEXT: 'user_context',
    USER_NOTIFICATION: 'notification',
    USER_SCORE: 'user_score',
    USER_POINT: 'point',
    VIOLATION_REPORT: 'violation_report'
};

const Functions = {
    PARSE_ARTICLE: 'funcParseArticle',
    PARSE_RSS_FEED: 'funcParseRSS'
};

/*
 * Public API Surface of common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CommentReactionTypes, CommentStatusList, Database, Functions, NotificationType, RatingStatusList, UserStatusList, ViolationReasonList, ViolationStatusList, arrayToChunks, createId, createSlugFromTitle, generateHash, reasonPoints };
